import clsx from 'clsx';
import { forwardRef } from 'react';
import { InputProps } from 'src/modules/common/components/DecimalField/types';
import { I18n } from 'src/modules/common/components/I18n/I18n.tsx';

export const DecimalInput = forwardRef(
    ({
        inputSize = 'md',
        disabled,
        endAdornment,
        labelText,
        labelPostfix,
        shaded = true,
        outlined = false,
        id,
        className,
        ...restProps
    }: InputProps, ref: React.Ref<HTMLInputElement>): React.ReactElement => (
        <div
            data-testid="decimal-input-wrapper"
            className={clsx(
                {
                    'vss-decimal-input-wrapper': true,
                },
                className,
            )}
        >
            <label
                data-testid="decimal-input-label"
                className={clsx(
                    {
                        'vss-decimal-input__label': true,
                        'vss-decimal-input__label--disabled': disabled,
                    },
                )}
                htmlFor={id}
            ><I18n messageId={labelText}/>{labelPostfix !== undefined ? labelPostfix : ''}
            </label>

            <div
                className="vss-decimal-input__end-adornment-wrapper"
            >
                <input
                    {...restProps}
                    data-testid={`decimal-input-${restProps.name}`}
                    id={id}
                    ref={ref}
                    disabled={disabled}
                    className={clsx({
                        'vss-decimal-input': true,
                        'vss-decimal-input--outlined': outlined,
                        'vss-decimal-input--shaded': shaded,
                        [`vss-decimal-input--${inputSize}`]: true,
                    })}
                />

                <div
                    className="vss-decimal-input__end-adornment"
                >
                    {endAdornment}
                </div>
            </div>
        </div>
    ),
);
